// Phone photos are 3-12MB. Sending those to the AI meant multi-minute waits and proxy
// timeouts, so the model gets a downscaled copy while the full original is still what we
// store as evidence (its EXIF/GPS proof stays untouched).
const MAX_EDGE = 1600;
const QUALITY = 0.82;

const readAsDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const fileToBase64 = async (file) => (await readAsDataUrl(file)).split(',')[1];

/** Returns base64 (no data: prefix) of a JPEG no larger than MAX_EDGE on its long side. */
export const prepareForAnalysis = async (file) => {
  try {
    const dataUrl = await readAsDataUrl(file);
    const img = await new Promise((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = reject;
      el.src = dataUrl;
    });

    const longest = Math.max(img.naturalWidth, img.naturalHeight);
    if (!longest) return dataUrl.split(',')[1];
    if (longest <= MAX_EDGE && file.size < 1_200_000) return dataUrl.split(',')[1];

    const scale = Math.min(1, MAX_EDGE / longest);
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', QUALITY).split(',')[1];
  } catch (e) {
    // Never block an upload because resizing failed — fall back to the original.
    return fileToBase64(file);
  }
};

export const ANALYSIS_TIMEOUT_MS = 120000;
